import React__default from 'react';
import { useIsMobile, useIsAppleMobile } from '@sravni/react-utils';
import { isSafari } from '@sravni/ugc/lib/helpers/isSafari';

const AppAnalyticsPixel = () => {
    const isMobile = useIsMobile();
    const isAppleMobile = useIsAppleMobile();
    if (!isAppleMobile || !isMobile || !isSafari)
        return null;
    return (React__default.createElement("img", { src: "https://www.sravni.ru/analytics-links/v1/redirects/mobileapps/?placement=sravni_global_safari_app_banners&is_retargeting=true", height: "1", width: "1", 
        // @ts-ignore
        border: "0" }));
};

export { AppAnalyticsPixel };
//# sourceMappingURL=AppAnalyticsPixel.js.map
